// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"37165cf7","372":"5c58f34c","766":"2aab441e"}[chunkId] + ".css";
};